(function($) {

    $(function() {
        console.log('user/form.js');
        let interval = false;

        $('#forgot_form').on('submit', function(e) {
            e.preventDefault();
            var $this = $(this);
            $('.validationerr', $this).html('<li>Sender...</li>');

            $.post('api/user/forgot', $this.serialize())
                .done(function() {
                    $('.validationerr', $this).html('<li>Der er blevet sendt en bekræftelsesmail til din email. <br/>'
                        + 'Husk at tjekke din spam/junk mappe, hvis du ikke kan se mailen.</li>').show();
                }).fail(function(response) {
                    var error_message = '<li>Kunne ikke finde brugeren.</li>';
                    handleError(response, error_message, $this);
                }
            );
            return false;
        });

        $('#login_form').on('submit', function(e) {
            e.preventDefault();
            var $this = $(this);
            $.post('api/user/login', $this.serialize())
                .done(function() {
                    location.href = $('input[name=href]', $this).val();
                }).fail(function(response) {
                var error_message = '<li>Kunne ikke logge ind.</li>';
                handleError(response, error_message, $this);

                var error = response.responseText;
                if(response.responseJSON) {
                    error = response.responseJSON;
                }
                // 403 == FORBIDDEN: This is what we send if the user needs to change their password
                if(response.status == 403 && error.token) {
                    // If we have an error token, we can reset our own password
                    $('.customer-password-update').fadeIn();
                    $('.customer-password-update input[name=token]').val(error.token);
                    $('.customer-password-update input[name=userEmail]').val($('input[name=email]', $this).val());
                    // } else if(response.status == 403) {
                    // vm.showForgotForm = true;
                }
            });
            return false;
        });

        $('#login_reset_form').on('submit', function(e) {
            e.preventDefault();
            var $this = $(this);

            // Convert form data to json
            var form_array = $this.serializeArray(),
                data = {};
            form_array.forEach(function(elm) {
                if(elm.name == 'formtok' || elm.name == 'kom_hp') {
                    // Skip formtok and honeypot
                    return;
                }
                data[elm.name] = elm.value;
            });

            $.ajax('api/user/reset_password',{
                contentType: 'application/json',
                data: JSON.stringify(data),
                method: 'post'
            })
                .done(function() {
                    $('#login_form .validationerr').html('<li>Dit password er blevet ændret. Du kan nu logge ind.</li>');
                    $('.validationerr', $this).hide();
                    $('.customer-password-update').hide();
                }).fail(function(response) {
                var error_message = '<li>Kunne ikke nulstille password.</li>';
                handleError(response, error_message, $this);
            });
            return false;
        });

        function handleError(response, defaultMessage, $form) {
            var error_message = defaultMessage;

            var error = response.responseText;

            if(response.responseJSON) {
                error = response.responseJSON;
            }

            if(response.status != 500 && error) {
                if(typeof error !== "string" && error.message) {
                    error_message += '<li>' + error.message + '</li>';
                } else {
                    if(error.toLowerCase().indexOf("please wait") === 0) {
                        error_message += '<li class="countdown">' + error + '</li>';
                    } else {
                        error_message += '<li>' + error + '</li>';
                    }
                }
            }

            $('.validationerr', $form).html(error_message).show();

            if(typeof error === "string" && error.toLowerCase().indexOf("please wait") === 0) {
                // Set up javascript countdown
                let sec_idx = error.length - 8, // " seconds".length
                    prefix_length = 12; // "please wait ".length
                let seconds = error.substring(prefix_length, sec_idx);

                intervalCountdown(seconds);
            }

            function intervalCountdown(init_seconds) {
                if(interval) {
                    clearInterval(interval);
                }
                // Set the interval to just over 1 second, in case people get too eager.
                interval = setInterval(countdown, 1050);

                let count = init_seconds,
                    $elm = $('.validationerr .countdown', $form);

                function countdown() {
                    if(count-- == 0) {
                        $elm.remove();
                        clearInterval(interval);
                        return;
                    }
                    let error = $elm.text(),
                        new_error = error.substr(0,12);
                    new_error += count;
                    new_error += " seconds";

                    $elm.text(new_error);
                }
            }
        }

        submitTo("#create_form", function(form) {
            var jqxhr = $.post("api/user/create",
                $("#create_form").serialize(),
                function() {
                    location.href = basepath + 'user';
                });

            jqxhr.fail(function() {
                $('#create_form .validationerr').html('<li>Kunne ikke oprette brugeren.</li>').show();
            });
        });
    });
})(jQuery);